module.exports = TalendReactCmf;